import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export default {
    title: "MyTrumpf/Partial Templates/Header Button Row",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const HeaderButtonRow = (data) => html`
    <div class="ux-row">
        <div class="ux-col-12">
            <div class="ux-u-d-flex ux-u-flex-jc-between ux-u-mb-xs">
                <a href="#" class="ux-button" title="back">
                    <ux-icon name="chevron-left"></ux-icon> Zurück
                </a>
                <div>${data.renderTestIds}</div>
                <div class="ux-u-d-flex">${unsafeHTML(data.buttons)}</div>
            </div>
        </div>
    </div>
`;

export const TwoButtonExample = HeaderButtonRow.bind({});
TwoButtonExample.args = {
    buttons: `<ux-button class='ux-u-mr-xxxs' label-visibility='m' icon='edit' icon-placement='end'>Maschine verwalten</ux-button><ux-iws-async-toggle-button class="ux-button ux-u-px-zero ux-u-px-md-s" on="">
  <span slot="on">
    <span class="ux-u-d-none ux-u-d-md-inline">Favorit</span>
    <ux-icon name="bookmark" filled=""></ux-icon>
  </span>
  <span slot="off">
    <span class="ux-u-d-none ux-u-d-md-inline">Favorisieren</span>
    <ux-icon name="bookmark"></ux-icon>
  </span>
</ux-iws-async-toggle-button>`,
};
